import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';

/**
 * get license templates
 * @returns {return license templates}
 */
export const getLicenseTemplates = (obj) => (dispatch) => {
  let query;
  if (!obj) {
    query = `${constants.API.GET_LICENSE_TEMPLATES}`;
  } else {
    query = `${constants.API.GET_LICENSE_TEMPLATES}?page=${obj.page}&size=${obj.size}`;
  }
  dispatch({
    payload: [],
    type: 'GET_LICENSE_TEMPLATES_REQUEST_INITIATED',
  });

  return httpservice()
    .get(query)
    .then((templateResponse) => {
      const rows = templateResponse.data.response.data.templates || templateResponse.data.response.data.rows;

      const count = templateResponse.data.response.data.totalItems || templateResponse.data.response.data.count;

      const responseData = rows.map((data) => (
        {
          ...data,
          created_at: dateFormat(data.createdAt),
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: 'GET_LICENSE_TEMPLATES_REQUEST_SUCCESS',
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: 'GET_LICENSE_TEMPLATES_REQUEST_ERROR',
      });
    });
};

export const createLicenseTemplate = (postData) => httpservice()
  .post(constants.API.LICENSE_TEMPLATE, postData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateLicenseTemplate = (updateData) => httpservice()
  .put(`${constants.API.LICENSE_TEMPLATE}`, updateData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const deleteLicenseTemplate = (id) => httpservice()
  .delete(`${constants.API.LICENSE_TEMPLATE}?id=${id}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);
